import { Component, OnInit, computed, signal } from '@angular/core';
import { TitleModel } from '../../../services/title.service';
import { OrderBaseComponent } from '../../../../features/orders/order-base.component';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss',
  standalone: false
})
export class PageTitleComponent extends OrderBaseComponent implements OnInit {

  title = signal<TitleModel | undefined>(undefined)
  forms = this.order
  startOrderDetails = this.orderStateService.getStartOrder
  interactionType = computed(() => this.preOrderDetails()?.InteractionType || '')
  agentId = computed(() => this.preOrderDetails()?.AgentId || '')
  location = computed(() => this.forms()?.orderSetup?.orderOptions?.location || '')
  campaignName = computed(() => this.startOrderDetails()?.Campaigns?.find(c => c.Id === +this.forms()?.orderSetup?.salesInformation?.campaign)?.Campaign || '')
  accountName = computed(() => {
    const account = this.forms()?.orderSetup?.salesInformation?.account
    const accounts = this.startOrderDetails()?.Accounts
    return (accounts?.find(a => a.Store === account) ?? accounts?.find(a => a.DealerCode === account))?.Store || ''
  })
  retailerName = computed(() => this.startOrderDetails()?.Retailers?.find(r => r.StoreName === this.forms()?.orderSetup?.salesInformation?.retailer)?.StoreName || '')
  storeName = computed(() => this.startOrderDetails()?.Stores?.find(s => s.DealerCode === this.forms()?.orderSetup?.salesInformation?.store)?.Store || '')
  salesPersonName = computed(() => this.startOrderDetails()?.SalesPersons?.find(s => s.UserId === +this.forms()?.orderSetup?.salesInformation?.salesPerson)?.FullName || '')
  ngOnInit(): void {
    this.subscriptions.add(this.titleService.listen().subscribe({
      next: (model) => {
        this.onTitleChange(model);
      }
    }))
    // Set Settings as title for user management
    if (window.location.pathname.includes('/user/usermanagement')) {
      this.title.set({ title: 'Settings' } as TitleModel);
    }
  }

  onTitleChange(model: TitleModel) {
    this.title.set(model);
  }

}
